import { metaToConsts } from "@/shared/lib/meta-to-consts";
import { metaToMap } from "@/shared/lib/meta-to-map";
import type { ValueMeta } from "@/shared/model";

type HttpErrorMeta = ValueMeta<number> & {
  description: string;
  message: string;
};

export const HTTP_ERROR_META = [
  {
    id: "HE01",
    name: "UNAUTHORIZED",
    label: "인증 필요",
    value: 401,
    description: "유효하지 않은 인증 정보 또는 토큰 누락",
    message: "로그인이 필요합니다. 다시 로그인해 주세요.",
  },
  {
    id: "HE02",
    name: "FORBIDDEN",
    label: "접근 권한 없음",
    value: 403,
    description: "인증은 되었으나 해당 리소스에 대한 권한 부재",
    message: "해당 페이지에 접근할 권한이 없습니다. 관리자에게 문의해 주세요.",
  },
  {
    id: "HE03",
    name: "NOT_FOUND",
    label: "리소스 없음",
    value: 404,
    description: "요청한 리소스를 서버에서 찾을 수 없음",
    message: "요청하신 페이지가 존재하지 않거나 삭제되었습니다.",
  },
  {
    id: "HE04",
    name: "UNPROCESSABLE_ENTITY",
    label: "입력값 오류",
    value: 422,
    description: "서버가 요청 본문의 유효성 검사를 통과하지 못함 (FastAPI)",
    message: "입력 정보를 확인해 주세요.",
  },
  {
    id: "HE05",
    name: "INTERNAL_SERVER_ERROR",
    label: "서버 오류",
    value: 500,
    description: "서버 내부에서 예기치 않은 오류 발생",
    message: "서버에 일시적인 문제가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  },
] as const satisfies readonly HttpErrorMeta[];

export const HTTP_ERROR_VALUE = metaToConsts(HTTP_ERROR_META);
export const HTTP_ERROR_MAP = metaToMap(HTTP_ERROR_META);
export type HttpErrorId = (typeof HTTP_ERROR_META)[number]["id"];
